import { render, staticRenderFns } from "./proofing.vue?vue&type=template&id=608c8372"
import script from "./proofing.vue?vue&type=script&lang=js"
export * from "./proofing.vue?vue&type=script&lang=js"
import style0 from "./proofing.vue?vue&type=style&index=0&id=608c8372&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports